import { CONTACT, whatsappHref, telHref } from "@/data/content";
import { WhatsAppIcon, PhoneIcon } from "@/components/icons";

export const WhatsAppButton = ({ compact = false, testid = "whatsapp-button", className = "" }) => {
  const href = whatsappHref();
  const cls = `group inline-flex items-center gap-3 rounded-full border px-6 py-3 text-xs font-medium uppercase tracking-[0.22em] transition-all duration-500 ${
    href
      ? "border-[#D4AF37]/45 text-slate-200 hover:border-[#25D366]/60 hover:text-white"
      : "cursor-not-allowed border-white/10 text-stone-500"
  } ${className}`;
  const icon = (
    <WhatsAppIcon
      className={`h-4 w-4 transition-colors duration-500 ${
        href ? "text-[#25D366]" : "text-stone-400"
      }`}
    />
  );
  const label = compact ? "WhatsApp" : "Chat on WhatsApp";

  if (!href) {
    return (
      <span data-testid={testid} className={cls} title="Available once the corporate number is announced">
        {icon}
        {label}
        <span className="text-[10px] normal-case tracking-normal text-stone-400">
          — coming soon
        </span>
      </span>
    );
  }
  return (
    <a
      data-testid={testid}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cls}
    >
      {icon}
      {label}
    </a>
  );
};

export const CallButton = ({ compact = false, testid = "call-button", className = "" }) => {
  const tel = telHref();
  if (!tel) return null;
  return (
    <a
      data-testid={testid}
      href={tel}
      className={`group inline-flex items-center gap-3 rounded-full border border-[#D4AF37]/45 px-6 py-3 text-xs font-medium uppercase tracking-[0.22em] text-slate-200 transition-all duration-500 hover:border-[#E7CE8B]/70 hover:text-white ${className}`}
    >
      <PhoneIcon className="h-4 w-4 text-[#E7CE8B]" />
      {compact ? "Call" : "Call Us"}
    </a>
  );
};

export const FloatingWhatsApp = () => {
  const href = whatsappHref();
  if (!href || !CONTACT.phone) return null;
  return (
    <a
      data-testid="floating-whatsapp"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Connect on WhatsApp"
      className="group fixed bottom-7 right-7 z-40 flex h-11 w-11 items-center justify-center rounded-full border border-[#D4AF37]/55 bg-[#12100A]/90 shadow-[0_0_0_3px_rgba(212,175,55,0.10),0_10px_30px_rgba(0,0,0,0.45)] backdrop-blur transition-all duration-500 hover:-translate-y-0.5 hover:border-[#D4AF37]/85 hover:shadow-[0_0_0_4px_rgba(212,175,55,0.16),0_12px_32px_rgba(0,0,0,0.5)]"
    >
      <WhatsAppIcon className="h-[18px] w-[18px] text-[#25D366] transition-transform duration-500 group-hover:scale-110" />
      <span className="pointer-events-none absolute right-full mr-4 whitespace-nowrap rounded-full border border-white/10 bg-[#12100A] px-4 py-2 text-xs font-normal tracking-wide text-slate-200 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
        Connect on WhatsApp
      </span>
    </a>
  );
};
